export interface Translations {
    [locale: string]: {
      [key: string]: string;
    };
  }
  
  const translations: Translations = {
    "en-US": {
        // Languages
        "English" : "English",
        "Finnish" : "Finnish",
        "Swedish" : "Swedish",
        "Norwegian" : "Norwegian",

        // Chart types
        "Chart type" : "Chart type",
        "Line" : "Line",
        "Bar" : "Bar",

        // Value Format
        "Value format" : "Value format",
        "Absolute" : "Absolute",
        "Change" : "Change",
        "Previous" : "Previous",

        // Share
        "Share" : "Share",
        "Print" : "Print",
        "Image (PNG)" : "Image (PNG)",
        "Image (png)" : "Image (png)",
        "Image (svg)" : "Image (svg)",
        "CSV" : "CSV",

        // Period Selector
        "Years": "Years",
        "Months": "Months",
        "Custom Period" : "Custom Period",
        "Dec - Feb" : "Dec - Feb",
        "Mar - May" : "Mar - May",
        "Jun - Aug" : "Jun - Aug",
        "Sep - Nov" : "Sep - Nov",
        "May - Oct" : "May - Oct",
        "Nov - Apr" : "Nov - Apr",
        "January" : "January",
        "February" : "February",
        "March" : "March",
        "April" : "April",
        "May" : "May",
        "June" : "June",
        "July" : "July",
        "August" : "August",
        "September" : "September",
        "October" : "October",
        "November" : "November",
        "December" : "December",
        "Jan" : "Jan",
        "Feb" : "Feb",
        "Mar" : "Mar",
        "Apr" : "Apr",
        "May_short": "May",
        "Jun" : "Jun",
        "Jul" : "Jul",
        "Aug" : "Aug",
        "Sep" : "Sep",
        "Oct" : "Oct",
        "Nov" : "Nov",
        "Dec" : "Dec",

        // Week days
        "Monday" : "Monday",
        "Tuesday" : "Tuesday",
        "Wednesday" : "Wednesday",
        "Thursday" : "Thursday",
        "Friday" : "Friday",
        "Saturday" : "Saturday",
        "Sunday" : "Sunday",
        "Mon" : "Mon",
        "Tue" : "Tue",
        "Wed" : "Wed",
        "Thu" : "Thu",
        "Fri" : "Fri",
        "Sat" : "Sat",
        "Sun" : "Sun",
        "Mo": "Mo",
        "Tu": "Tu",
        "We": "We",
        "Th": "Th",
        "Fr": "Fr",
        "Sa": "Sa",
        "Su": "Su",

        // Custom Period
        "Select" : "Select",
        "From" : "From",
        "To" : "To",

        // Date Picker
        "Select Date" : "Select Date",
        "Month": "Month",
        "Year": "Year",
        "Aggregation": "Aggregation",
        "Aggregate": "Aggregate",
        "Latest": "Latest",

        // Date Range Selector
        "Select date range": "Select date range",
        "Cancel": "Cancel",

        // Feedback drawer
        "Feedback": "Feedback",
        "Experienced a bug or just want to give a feedback? Please fill the form below so we can improve your experience!": "Experienced a bug or just want to give a feedback? Please fill the form below so we can improve your experience!",
        "Name (Optional)": "Name (Optional)",
        "Email (Optional)": "Email (Optional)",
        "Enter your feedback here": "Enter your feedback here",
        "Please enter your feedback": "Please enter your feedback",
        "Submit": "Submit",
        "Thank you for your feedback!": "Thank you for your feedback!",
        "Failed to send feedback. Please try again later.": "Failed to send feedback. Please try again later.",

        // Visualization types
        "Chart" : "Chart",
        "Table" : "Table",
        "Figure" : "Figure",

        // Buttons
        "Add content" : "Add content",
        "Edit content" : "Edit content",
        "Add data" : "Add data",
        "Show chart" : "Show chart",
        "Show table" : "Show table",
        "Show figure" : "Show figure",
        "Back" : "Back",
        "New visualization" : "New visualization",
        "Reset page" : "Reset page",
        "Reset page?": "Reset page?",
        "Remove" : "Remove",
        "Full screen" : "Full screen",
        "Resize" : "Resize",
        "Choose period" : "Choose period",
        "Apply" : "Apply",
        "Close" : "Close",
        "Search" : "Search",
        "Presentation mode" : "Presentation mode",

        // Highchart timeseries
        "Sources" : "Sources",
        "sources" : "sources",

        // Range selector
        "Zoom" : "Zoom",
        "Zoom in" : "Zoom in",
        "Zoom out" : "Zoom out",
        "Reset zoom" : "Reset zoom",

        // Table
        "Date" : "Date",

        // Menu Navigation bar
        "Home" : "Home",
        "About" : "About",
        "Contact" : "Contact",
        "Premium" : "Premium",
        "Dashboard" : "Dashboard",
        "Regions" : "Regions",
        "Blog" : "Blog",
        "Help" : "Help",
        "Dictionary" : "Dictionary",
        "Tourism research" : "Tourism research",
        "Foreign Tourists" : "Foreign Tourists",
        "Tourism Employment & Income" : "Tourism Employment & Income",
        "Travel Analytics" : "Travel Analytics",
        "FAQ" : "FAQ",
        "Privacy policy" : "Privacy policy",
        "Logout" : "Logout",

        // Visualization size
        "Small" : "Small",
        "Medium" : "Medium",
        "Large" : "Large",
        "Horizontal Size" : "Horizontal Size",
        "Vertical Size" : "Vertical Size",

        // Selector
        "Statistics" : "Statistics",
        "Type to search..." : "Type to search...",

        // Value Format
        "million" : "million",
        "billion" : "billion",
        "mill" : "mill",
        "bill" : "bill",

        // View Dropdown
        "Views" : "Views",
        "My Views" : "My Views",
        "Organization Views" : "Organization Views",
        "Save" : "Save",
        "Overwrite" : "Overwrite",
        "No views" : "No views",
        "No organization views" : "No organization views",
        "saved" : "saved",
        "updated" : "updated",
        "Error saving view. Please try again." : "Error saving view. Please try again.",
        "Please enter a name." : "Please enter a name.",
        "View already exists. Do you want to overwrite it?" : "View already exists. Do you want to overwrite it?",
        "View already exists. Please choose another name." : "View already exists. Please choose another name.",
        "View already exists on your organization. Please choose another name." : "View already exists on your organization. Please choose another name.",
        "Enter View Name" : "Enter View Name",

        // Visualization container
        "Are you sure you want to remove this visualization?" : "Are you sure you want to remove this visualization?",
        "This action cannot be undone. All the data associated with this visualization will be lost." : "This action cannot be undone. All the data associated with this visualization will be lost.",
        "OK": "OK",

        // Custom Error
        "Select content": "Select content",
        "Unavailable Data": "Unavailable Data",
        "Remove Container": "Remove Container",
        "This error might dissappear on page reload": "This error might dissappear on page reload",

        // Other
        "Loading" : "Loading",
        "Start with your first visualization": "Start with your first visualization",
        "Chart initialization failed": "Chart initialization failed",
    },

    "fi-FI": {
        // Languages
        "English" : "English",
        "Finnish" : "Finnish",
        "Swedish" : "Swedish",
        "Norwegian" : "Norwegian",

        // Chart types
        "Chart type" : "Kaavion tyyppi",
        "Line" : "Viiva",
        "Bar" : "Pylväs",
        
        // Value Format
        "Value format" : "Arvon muoto",
        "Absolute" : "Absoluuttinen",
        "Change" : "Muutos",
        "Previous" : "Edellinen",

        // Share
        "Share" : "Jaa",
        "Print" : "Tulosta",
        "Image (PNG)" : "Kuva (PNG)",
        "Image (SVG)" : "Kuva (SVG)",
        "Image (png)" : "Kuva (png)",
        "Image (svg)" : "Kuva (svg)",
        "CSV" : "CSV",

        // Period Selector
        "Years": "Vuodet",
        "Months": "Kuukaudet",
        "Custom Period" : "Oma ajanjakso",
        "Dec - Feb" : "Joulu - Helmi",
        "Mar - May" : "Maalis - Touko",
        "Jun - Aug" : "Kesä - Elo",
        "Sep - Nov" : "Syys - Marras",
        "Nov - Apr" : "Marras - Huhti",
        "May - Oct" : "Touko - Loka",
        "January" : "Tammikuu",
        "February" : "Helmikuu",
        "March" : "Maaliskuu",
        "April" : "Huhtikuu",
        "May" : "Toukokuu",
        "June" : "Kesäkuu",
        "July" : "Heinäkuu",
        "August" : "Elokuu",
        "September" : "Syyskuu",
        "October" : "Lokakuu",
        "November" : "Marraskuu",
        "December" : "Joulukuu",
        "Jan" : "Tammi",
        "Feb" : "Helmi",
        "Mar" : "Maalis",
        "Apr" : "Huhti",
        "May_short": "Touko",
        "Jun" : "Kesä",
        "Jul" : "Heinä",
        "Aug" : "Elo",
        "Sep" : "Syys",
        "Oct" : "Loka",
        "Nov" : "Marras",
        "Dec" : "Joulu",

        // Week days
        "Monday" : "Maanantai",
        "Tuesday" : "Tiistai",
        "Wednesday" : "Keskiviikko",
        "Thursday" : "Torstai",
        "Friday" : "Perjantai",
        "Saturday" : "Lauantai",
        "Sunday" : "Sunnuntai",
        "Mon" : "Ma",
        "Tue" : "Ti",
        "Wed" : "Ke",
        "Thu" : "To",
        "Fri" : "Pe",
        "Sat" : "La",
        "Sun" : "Su",
        "Mo": "Ma",
        "Tu": "Ti",
        "We": "Ke",
        "Th": "To",
        "Fr": "Pe",
        "Sa": "La",
        "Su": "Su",

        // Custom Period
        "Select" : "Valitse",
        "From" : "Alkaen",
        "To" : "Päättyen",

        // Date Picker
        "Select Date" : "Valitse päivämäärä",
        "Month": "Kuukausi",
        "Year": "Vuosi",
        "Aggregation": "Agregointi",
        "Aggregate": "Agregoi",
        "Latest": "Viimeisin",

        // Date Range Selector
        "Select date range": "Valitse aikaväli",
        "Cancel": "Peruuta",

        // Feedback drawer
        "Feedback": "Palaute",
        "Experienced a bug or just want to give a feedback? Please fill the form below so we can improve your experience!": "Oletko havainnut virheen tai haluat antaa palautetta? Täytä alla oleva lomake, jotta voimme parantaa kokemustasi!",
        "Name (Optional)": "Nimi (Valinnainen)",
        "Email (Optional)": "Sähköposti (Valinnainen)",
        "Enter your feedback here": "Kirjoita palautteesi tähän",
        "Please enter your feedback": "Annathan palautteesi, kiitos",
        "Submit": "Lähetä",
        "Thank you for your feedback!": "Kiitos palautteestasi!",
        "Failed to send feedback. Please try again later.": "Palautteen lähettäminen epäonnistui. Yritä myöhemmin uudelleen.",

        // Visualization types
        "Chart" : "Kaavio",
        "Table" : "Taulukko",
        "Figure" : "Luvut",

        // Buttons
        "Add content" : "Lisää sisältöä",
        "Edit content" : "Muokkaa sisältöä",
        "Add data" : "Lisää dataa",
        "Show chart" : "Näytä kaavio",
        "Show table" : "Näytä taulukko",
        "Show figure" : "Näytä luku",
        "Back" : "Takaisin",
        "New visualization" : "Uusi visualisointi",
        "Reset page" : "Nollaa sivu",
        "Reset page?": "Nollaa sivu?",
        "Remove" : "Poista",
        "Full screen" : "Koko näyttö",
        "Resize" : "Muuta kokoa",
        "Choose period" : "Valitse ajanjakso",
        "Apply" : "Hyväksy",
        "Close" : "Sulje",
        "Search" : "Hae",
        "Presentation mode" : "Esitystila",

        // Highchart timeseries
        "Sources" : "Lähteet",
        "sources" : "lähteet",

        // Range selector
        "Zoom" : "Zoom",
        "Zoom in" : "Zoom in",
        "Zoom out" : "Zoom out",
        "Reset zoom" : "Reset zoom",

        // Table
        "Date" : "Päivämäärä",

        // Menu Navigation bar
        "Home" : "Alkuun",
        "About" : "Tietoa",
        "Premium" : "Premium",
        "Dashboard" : "Dashboard",
        "Regions" : "Alueet",
        "Blog" : "Blogi",
        "Help" : "Neuvonta",
        "Dictionary" : "Sanasto",
        "Tourism research" : "Matkailututkimus",
        "Foreign Tourists" : "Ulkomaalaiset matkailijat",
        "Tourism Employment & Income" : "Matkailun tulo- ja työllisyystutkimus",
        "Travel Analytics" : "Matkailun analytiikka",
        "FAQ" : "UKK",
        "Contact" : "Yhteystiedot",
        "Privacy policy" : "Tietosuojakäytäntö",
        "Logout" : "Kirjaudu ulos",

        // Visualization size
        "Small" : "Pieni",
        "Medium" : "Keskikokoinen",
        "Large" : "Suuri",
        "Horizontal Size" : "Vaakasuuntainen",
        "Vertical Size" : "Pystysuuntainen",

        // Selector
        "Statistics" : "Tilastot",
        "Type to search..." : "Kirjoita etsiäksesi...",

        // Value Format
        "million" : "miljoonaa",
        "billion" : "miljardia",
        "mill" : "milj",
        "bill" : "mrd",

        // View Dropdown
        "Views" : "Näkymät",
        "My Views" : "Minun näkymät",
        "Organization Views" : "Organisaation näkymät",
        "Save" : "Tallenna",
        "Overwrite" : "Ylikirjoita",
        "No views" : "Ei näkymiä",
        "No organization views" : "Ei organisaation näkymiä",
        "saved" : "tallennettu",
        "updated" : "päivitetty",
        "Error saving view. Please try again." : "Virhe näkymän tallentamisessa. Yritä uudelleen.",
        "Please enter a name." : "Kirjoita nimi.",
        "View already exists. Do you want to overwrite it?" : "Näkymä on jo olemassa. Haluatko ylikirjoittaa sen?",
        "View already exists. Please choose another name." : "Näkymä on jo olemassa. Valitse toinen nimi.",
        "View already exists on your organization. Please choose another name." : "Näkymä on jo olemassa organisaatiossasi. Valitse toinen nimi.",
        "Enter View Name" : "Kirjoita näkymän nimi",

        // Visualization container
        "Are you sure you want to remove this visualization?" : "Haluatko varmasti poistaa tämän visualisoinnin?",
        "This action cannot be undone. All the data associated with this visualization will be lost." : "Tätä toimintoa ei voi perua. Kaikki visualisointiin liittyvät tiedot menetetään.",
        "OK": "OK",

        // Custom Error
        "Select content": "Valitse sisältö",
        "Unavailable Data": "Dataa ei saatavilla",
        "Remove Container": "Poista visualisointi",
        "This error might dissappear on page reload.": "Tämä virhe saattaa korjaantua sivun uudelleenlatauksella.",

        // Other
        "Loading" : "Ladataan",
        "Start with your first visualization": "Aloita ensimmäisellä visualisoinnillasi",
        "Chart initialization failed": "Kaavion luominen epäonnistui",
    },

    "sv-SE": {
        // Languages
        "English": "English",
        "Finnish": "Finnish",
        "Swedish": "Swedish",
        "Norwegian": "Norwegian",
    
        // Chart types
        "Chart type": "Diagramtyp",
        "Line": "Linje",
        "Bar": "Stapeldiagram",
    
        // Value Format
        "Value format": "Värdeformat",
        "Absolute": "Absolut",
        "Change": "Förändring",
        "Previous": "Föregående",
    
        // Share
        "Share": "Dela",
        "Print": "Skriv ut",
        "Image (PNG)": "Bild (PNG)",
        "Image (SVG)": "Bild (SVG)",
        "Image (png)": "Bild (png)",
        "Image (svg)": "Bild (svg)",
        "CSV": "CSV",
    
        // Period Selector
        "Years": "År",
        "Months": "Månader",
        "Custom Period": "Anpassad period",
        "Dec - Feb": "Dec - Feb",
        "Mar - May": "Mar - Maj",
        "Jun - Aug": "Jun - Aug",
        "Sep - Nov": "Sep - Nov",
        "Nov - Apr": "Nov - Apr",
        "May - Oct": "Maj - Okt",
        "January": "Januari",
        "February": "Februari",
        "March": "Mars",
        "April": "April",
        "May": "Maj",
        "June": "Juni",
        "July": "Juli",
        "August": "Augusti",
        "September": "September",
        "October": "Oktober",
        "November": "November",
        "December": "December",
        "Jan": "Jan",
        "Feb": "Feb",
        "Mar": "Mar",
        "Apr": "Apr",
        "May_short": "Maj",
        "Jun": "Jun",
        "Jul": "Jul",
        "Aug": "Aug",
        "Sep": "Sep",
        "Oct": "Okt",
        "Nov": "Nov",
        "Dec": "Dec",
    
        // Week days
        "Monday": "Måndag",
        "Tuesday": "Tisdag",
        "Wednesday": "Onsdag",
        "Thursday": "Torsdag",
        "Friday": "Fredag",
        "Saturday": "Lördag",
        "Sunday": "Söndag",
        "Mon": "Mån",
        "Tue": "Tis",
        "Wed": "Ons",
        "Thu": "Tor",
        "Fri": "Fre",
        "Sat": "Lör",
        "Sun": "Sön",
        "Mo": "Må",
        "Tu": "Ti",
        "We": "On",
        "Th": "To",
        "Fr": "Fr",
        "Sa": "Lö",
        "Su": "Sö",
    
        // Custom Period
        "Select": "Välj",
        "From": "Från",
        "To": "Till",
    
        // Date Picker
        "Select Date": "Välj datum",
        "Month": "Månad",
        "Year": "År",
        "Aggregation": "Aggregering",
        "Aggregate": "Aggregat",
        "Latest": "Senast",

        // Date Range Selector
        "Select date range": "Välj datumintervall",
        "Cancel": "Avbryt",

        // Feedback drawer
        "Feedback": "Feedback",
        "Experienced a bug or just want to give a feedback? Please fill the form below so we can improve your experience!": "Upplevde du ett fel eller vill du bara ge feedback? Fyll i formuläret nedan så att vi kan förbättra din upplevelse!",
        "Name (Optional)": "Namn (Valfritt)",
        "Email (Optional)": "E-post (Valfritt)",
        "Enter your feedback here": "Skriv din feedback här",
        "Please enter your feedback": "Vänligen skriv din feedback",
        "Submit": "Skicka",
        "Thank you for your feedback!": "Tack för din feedback!",
        "Failed to send feedback. Please try again later.": "Det gick inte att skicka feedback. Försök igen senare.",
    
        // Visualization types
        "Chart": "Diagram",
        "Table": "Tabell",
        "Figure": "Siffra",
    
        // Buttons
        "Add content": "Lägg till innehåll",
        "Edit content": "Redigera innehåll",
        "Add data": "Lägg till data",
        "Show chart": "Visa diagram",
        "Show table": "Visa tabell",
        "Show figure": "Visa siffra",
        "Back": "Tillbaka",
        "New visualization": "Ny visualisering",
        "Reset page": "Återställ sida",
        "Reset page?": "Återställ sida?",
        "Remove": "Ta bort",
        "Full screen": "Helskärm",
        "Resize": "Ändra storlek",
        "Choose period": "Välj period",
        "Apply": "Tillämpa",
        "Close": "Stänga",
        "Search": "Sök",
        "Presentation mode": "Presentation läge",
    
        // Highchart timeseries
        "Sources": "Källor",
        "sources": "källor",
    
        // Range selector
        "Zoom": "Zooma",
        "Zoom in": "Zooma in",
        "Zoom out": "Zooma ut",
        "Reset zoom": "Återställ zoom",
    
        // Table
        "Date": "Datum",
    
        // Menu Navigation bar
        "Home": "Hem",
        "About": "Om",
        "Premium": "Premium",
        "Dashboard": "Dashboard",
        "Regions": "Regioner",
        "Blog": "Blogg",
        "Help" : "Hjälp",
        "Dictionary": "Ordlista",
        "Tourism research": "Turismforskning",
        "Foreign Tourists": "Utländska turister",
        "Tourism Employment & Income": "Turismens sysselsättning och inkomst",
        "Travel Analytics": "Reseanalys",
        "FAQ": "Vanliga frågor",
        "Contact": "Kontakt",
        "Privacy policy": "Integritetspolicy",
        "Logout": "Logga ut",
    
        // Visualization size
        "Small": "Liten",
        "Medium": "Medium",
        "Large": "Stor",
        "Horizontal Size": "Horisontell storlek",
        "Vertical Size": "Vertikal storlek",
    
        // Selector
        "Statistics": "Statistik",
        "Type to search...": "Skriv för att söka...",
    
        // Value Format
        "million": "miljoner",
        "billion": "miljarder",
        "mill": "milj",
        "bill": "mrd",

        // View Dropdown
        "Views": "Visningar",
        "My Views": "Mina visningar",
        "Organization Views": "Organisationsvisningar",
        "Save": "Spara",
        "Overwrite": "Skriv över",
        "No views": "Inga visningar",
        "No organization views": "Inga organisationsvisningar",
        "saved": "sparad",
        "updated": "uppdaterad",
        "Error saving view. Please try again.": "Fel vid sparande av visning. Försök igen.",
        "Please enter a name.": "Ange ett namn.",
        "View already exists. Do you want to overwrite it?": "Visning finns redan. Vill du skriva över den?",
        "View already exists. Please choose another name.": "Visning finns redan. Välj ett annat namn.",
        "View already exists on your organization. Please choose another name.": "Visning finns redan i din organisation. Välj ett annat namn.",
        "Enter View Name": "Ange visningsnamn",

        // Visualization container
        "Are you sure you want to remove this visualization?" : "Är du säker på att du vill ta bort denna visualisering?",
        "This action cannot be undone. All the data associated with this visualization will be lost." : "Denna åtgärd kan inte ångras. All data som är associerad med denna visualisering kommer att gå förlorad.",
        "OK": "OK",

        // Custom Error
        "Select content": "Välj innehåll",
        "Unavailable Data": "Otillgängliga data",
        "Remove Container": "Ta bort visualisering",
        "This error might dissappear on page reload": "Detta fel kan försvinna vid uppdatering av sidan",

        // Other
        "Loading": "Laddar",
        "Start with your first visualization": "Börja med din första visualisering",
        "Chart initialization failed": "Det gick inte att skapa diagram",
    },  

    "nb-NO": {
        // Languages
        "English": "English",
        "Finnish": "Finnish",
        "Swedish": "Swedish",
        "Norwegian": "Norwegian",
    
        // Chart types
        "Chart type": "Diagramtype",
        "Line": "Linje",
        "Bar": "Stolpe",
    
        // Value Format
        "Value format": "Verdi format",
        "Absolute": "Absolutt",
        "Change": "Endring",
        "Previous": "Forrige",
    
        // Share
        "Share": "Del",
        "Print": "Skriv ut",
        "Image (PNG)": "Bilde (PNG)",
        "Image (SVG)": "Bilde (SVG)",
        "Image (png)": "Bilde (png)",
        "Image (svg)": "Bilde (svg)",
        "CSV": "CSV",
    
        // Period Selector
        "Years": "År",
        "Months": "Måneder",
        "Custom Period": "Egendefinert periode",
        "Dec - Feb": "Des - Feb",
        "Mar - May": "Mar - Mai",
        "Jun - Aug": "Jun - Aug",
        "Sep - Nov": "Sep - Nov",
        "Nov - Apr": "Nov - Apr",
        "May - Oct": "Mai - Okt",
        "January": "Januar",
        "February": "Februar",
        "March": "Mars",
        "April": "April",
        "May": "Mai",
        "June": "Juni",
        "July": "Juli",
        "August": "August",
        "September": "September",
        "October": "Oktober",
        "November": "November",
        "December": "Desember",
        "Jan": "Jan",
        "Feb": "Feb",
        "Mar": "Mar",
        "Apr": "Apr",
        "May_short": "Mai",
        "Jun": "Jun",
        "Jul": "Jul",
        "Aug": "Aug",
        "Sep": "Sep",
        "Oct": "Okt",
        "Nov": "Nov",
        "Dec": "Des",
    
        // Week days
        "Monday": "Mandag",
        "Tuesday": "Tirsdag",
        "Wednesday": "Onsdag",
        "Thursday": "Torsdag",
        "Friday": "Fredag",
        "Saturday": "Lørdag",
        "Sunday": "Søndag",
        "Mon": "Man",
        "Tue": "Tir",
        "Wed": "Ons",
        "Thu": "Tor",
        "Fri": "Fre",
        "Sat": "Lør",
        "Sun": "Søn",
        "Mo": "Ma",
        "Tu": "Ti",
        "We": "On",
        "Th": "To",
        "Fr": "Fr",
        "Sa": "Lø",
        "Su": "Sø",
    
        // Custom Period
        "Select": "Velg",
        "From": "Fra",
        "To": "Til",
    
        // Date Picker
        "Select Date": "Velg dato",
        "Month": "Måned",
        "Year": "År",
        "Aggregation": "Aggregering",
        "Aggregate": "Aggreger",
        "Latest": "Siste",

        // Date Range Selector
        "Select date range": "Velg datoperiode",
        "Cancel": "Avbryt",

        // Feedback drawer
        "Feedback": "Tilbakemelding",
        "Experienced a bug or just want to give a feedback? Please fill the form below so we can improve your experience!": "Opplevde du en feil eller vil du bare gi tilbakemelding? Vennligst fyll ut skjemaet nedenfor, så vi kan forbedre din opplevelse!",
        "Name (Optional)": "Navn (Valgfritt)",
        "Email (Optional)": "E-post (Valgfritt)",
        "Enter your feedback here": "Skriv din tilbakemelding her",
        "Please enter your feedback": "Vennligst skriv din tilbakemelding",
        "Submit": "Send",
        "Thank you for your feedback!": "Takk for din tilbakemelding!",
        "Failed to send feedback. Please try again later.": "Kunne ikke sende tilbakemelding. Vennligst prøv igjen senere.",
    
        // Visualization types
        "Chart": "Diagram",
        "Table": "Tabell",
        "Figure": "Figur",
    
        // Buttons
        "Add content": "Legg til innhold",
        "Edit content": "Rediger innhold",
        "Add data": "Legg til data",
        "Show chart": "Vis diagram",
        "Show table": "Vis tabell",
        "Show figure": "Vis figur",
        "Back": "Tilbake",
        "New visualization": "Ny visualisering",
        "Reset page": "Tilbakestill side",
        "Reset page?": "Tilbakestill side?",
        "Remove": "Fjern",
        "Full screen": "Full skjerm",
        "Resize": "Endre størrelse",
        "Choose period": "Velg periode",
        "Apply": "Bruk",
        "Close": "Lukk",
        "Search": "Søk",
        "Presentation mode": "Presentasjonsmodus",
    
        // Highchart timeseries
        "Sources": "Kilder",
        "sources": "kilder",
    
        // Range selector
        "Zoom": "Zoom",
        "Zoom in": "Zoom inn",
        "Zoom out": "Zoom ut",
        "Reset zoom": "Tilbakestill zoom",
    
        // Table
        "Date": "Dato",
    
        // Menu Navigation bar
        "Home": "Hjem",
        "About": "Om",
        "Premium": "Premium",
        "Dashboard": "Dashboard",
        "Regions": "Regioner",
        "Blog": "Blogg",
        "Help" : "Hjelp",
        "Dictionary": "Ordbok",
        "Tourism research": "Turismeforskning",
        "Foreign Tourists": "Utenlandske turister",
        "Tourism Employment & Income": "Turisme sysselsetting og inntekt",
        "Travel Analytics": "Reiseanalyse",
        "FAQ": "FAQ",
        "Contact": "Kontakt",
        "Privacy policy": "Personvern",
        "Logout": "Logg ut",
    
        // Visualization size
        "Small": "Liten",
        "Medium": "Medium",
        "Large": "Stor",
        "Horizontal Size": "Horisontal størrelse",
        "Vertical Size": "Vertikal størrelse",
    
        // Selector
        "Statistics": "Statistikk",
        "Type to search...": "Skriv for å søke...",
    
        // Value Format
        "million": "millioner",
        "billion": "milliarder",
        "mill": "mill",
        "bill": "mrd",

        // View Dropdown
        "Views": "Visninger",
        "My Views": "Mine visninger",
        "Organization Views": "Organisasjonsvisninger",
        "Save": "Lagre",
        "Overwrite": "Overskriv",
        "No views": "Ingen visninger",
        "No organization views": "Ingen organisasjonsvisninger",
        "saved": "lagret",
        "updated": "oppdatert",
        "Error saving view. Please try again.": "Feil ved lagring av visning. Prøv igjen.",
        "Please enter a name.": "Vennligst skriv inn et navn.",
        "View already exists. Do you want to overwrite it?": "Visningen finnes allerede. Vil du overskrive den?",
        "View already exists. Please choose another name.": "Visningen finnes allerede. Vennligst velg et annet navn.",
        "View already exists on your organization. Please choose another name.": "Visningen finnes allerede i organisasjonen din. Vennligst velg et annet navn.",
        "Enter View Name": "Skriv inn visningsnavn",

        // Visualization container
        "Are you sure you want to remove this visualization?" : "Er du sikker på at du vil fjerne denne visualiseringen?",
        "This action cannot be undone. All the data associated with this visualization will be lost." : "Denne handlingen kan ikke angres. Alle dataene som er assosiert med denne visualiseringen vil gå tapt.",
        "OK": "OK",

        // Custom Error
        "Select content": "Velg innhold",
        "Unavailable Data": "Utilgjengelige data",
        "Remove Container": "Fjern visualisering",
        "This error might dissappear on page reload": "Denne feilen kan forsvinne ved å laste siden på nytt",

        // Other
        "Loading": "Laster",
        "Start with your first visualization": "Start med din første visualisering",
        "Chart initialization failed": "Kunne ikke opprette diagram",
    }
  
  };
  
  export default translations;